/**
 * The memo's source numbers, handed to every sentence without threading a
 * prop through each paragraph and table (DOP-616). A surface outside the
 * memo (no provider) gets no numbers, so its sentences show no chips.
 */

import { createContext, useContext } from "react";

export const SourceNumberContext = createContext<ReadonlyMap<string, number> | null>(null);

/** The number for a source anchor, or null when the memo does not number it. */
export const useSourceNumber = (anchor: string | null | undefined): number | null => {
	const numbers = useContext(SourceNumberContext);
	if (!numbers || !anchor) return null;
	return numbers.get(anchor) ?? null;
};
